package com.essntl.features.message.data.supabase.message

import com.essntl.features.message.domain.model.MessageModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun MessageModel.toRequestMap(): Map<String, JsonElement> {
    val messageMap = mutableMapOf<String, JsonElement>()

    messageMap["user_text"] = JsonPrimitive(userText)

    messageMap["platform_id"] = JsonPrimitive(platformId)

    itineraryService?.let { i ->
        messageMap["itinerary_service_id"] = JsonPrimitive(i.id)
    }

    if (sender.id.isNotEmpty())
        messageMap["sender_id"] = JsonPrimitive(sender.id)

    when (val type = type) {
        is MessageModel.Type.Email -> {
            messageMap["recipient"] = JsonPrimitive(type.email)
            messageMap["type"] = JsonPrimitive("EMAIL")
        }

        is MessageModel.Type.Sms -> {
            messageMap["recipient"] = JsonPrimitive(type.phone)
            messageMap["type"] = JsonPrimitive("SMS")
        }

        is MessageModel.Type.Whatsapp -> {
            messageMap["recipient"] = JsonPrimitive(type.phone)
            messageMap["type"] = JsonPrimitive("WHATSAPP")
        }
    }

    return messageMap
}
